import { IGeographicAddress } from '@features/eligibility/interfaces';
import axios, { AxiosResponse } from 'axios';

import { env } from '../../../config';
import { Site } from '../types';

export const fetchSite = async (address: IGeographicAddress): Promise<AxiosResponse<Site>> => {
  const neliResponse: AxiosResponse<Site> = await axios.get(
    `${env.API_URL}/dataraccov2/buildingDetails`,
    {
      params: { buildingRef: address.buildingRef }
    }
  );
  return neliResponse;
};
